var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgAudiences = function SvgAudiences(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 19.826,
    cy: 4.696,
    r: 2.609,
    fill: "#93f2ff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.174,
    cy: 4.696,
    r: 2.609,
    fill: "#93f2ff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#93f2ff",
    d: "M18.26 8.348a2.605 2.605 0 00-2.608 2.61v3.544c0 .29.218.611.487.719l1.078.431.479 5.738a.58.58 0 00.563.523h3.134a.58.58 0 00.564-.523l.478-5.738 1.07-.356a.772.772 0 00.495-.687V10.96a2.611 2.611 0 00-2.607-2.612h-3.134zm-15.653 0A2.605 2.605 0 000 10.958v3.544c0 .29.218.611.487.719l1.078.431.478 5.738a.58.58 0 00.564.523h3.134a.58.58 0 00.563-.523l.479-5.738 1.07-.356a.772.772 0 00.495-.687V10.96A2.611 2.611 0 005.74 8.348H2.607z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 3.13,
    r: 3.13,
    fill: "#5ebfd5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5ebfd5",
    d: "M9.913 7.304a3.128 3.128 0 00-3.13 3.133v4.693c0 .288.207.626.463.754l1.624.812.523 6.826a.52.52 0 00.52.478h4.174a.52.52 0 00.52-.478l.49-6.933 1.64-.724a.87.87 0 00.48-.735v-4.693a3.128 3.128 0 00-3.13-3.133H9.913z"
  }))));
};
export default SvgAudiences;